import { gql } from '@apollo/client'
import client from '../utils/client'
import { MutationHandlerResult } from '../utils/errors'

export type DeleteImportedMenuArgs = { restaurantId: string }

const deleteImportedMenu = async ({
	restaurantId,
}: DeleteImportedMenuArgs): Promise<MutationHandlerResult> => {
	try {
		const { data, errors } = await client.mutate({
			mutation: gql`
				mutation DeleteImportedMenu($restaurantId: ID!) {
					deleteImportedMenu(restaurantId: $restaurantId) {
						success
					}
				}
			`,
			variables: { restaurantId },
			refetchQueries: ['CurrentUser'],
			awaitRefetchQueries: true,
		})

		if (errors) {
			return { success: false, errors }
		}

		return { success: Boolean(data?.deleteImportedMenu?.success), errors: null }
	} catch (e) {
		if (e instanceof Error && 'networkError' in e && e.networkError) {
			return { success: false, errors: 'NETWORK_ERROR' }
		}
		throw e
	}
}

export default deleteImportedMenu
